// NPM Imports
import React from "react";
import * as Sentry from "@sentry/browser";

// Internal Imports
import { GlobalUtils } from "../../utils";

const _triggerSentryError = ({ error, level, tag }) => {
  Sentry.configureScope(scope => {
    const CURRENT_USER = GlobalUtils.readDataFromLocalStorage("revvsalesUser");
    scope.setLevel(level);
    scope.setTag("custom_tag", tag);
    scope.setExtra(
      "user-email",
      (CURRENT_USER && CURRENT_USER.user_email) || "",
    );
    scope.setExtra("app_version", process.env.REACT_APP_VERSION);
    scope.setExtra("payload", JSON.stringify(error));
    Sentry.captureException(error);
  });
};

const _retry = (component, retriesLeft = 2, interval = 1000) =>
  new Promise((resolve, reject) => {
    component()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            _triggerSentryError({
              error,
              level: "critical",
              tag: "Chunk Load Failed",
            });
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }
          _triggerSentryError({
            error,
            level: "info",
            tag: "Chunk Load Retried",
          });
          // Passing on "reject" is the important part
          _retry(component, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });

const lazyLoad = component => React.lazy(() => _retry(component));

export default lazyLoad;
